import * as React from 'react';
import { IconsAvailable } from '../../Components/Icon';
import HeadingWithButtons from '../../Components/HeadingWithButtons';
import { IButtonProps} from '../../Components/Button';

export interface ILayoutSidebarPrimaryProps {
    /** Column title */
    title: React.ReactNode;
    /** Title actions */
    titleActions?: IButtonProps[];
    /** Icon for column title */
    icon?: IconsAvailable;
    /** className to append */
    className?: string;
}

interface IState {
}

/**
 * Primary column to be used inside LayoutSidebar
 */
class LayoutSidebarPrimary extends React.Component<ILayoutSidebarPrimaryProps, IState> {
    static displayName: string = 'LayoutSidebarPrimary';

    render () {
        return (
            <div className="layout-sidebar-primary">
                <HeadingWithButtons
                    title={this.props.title}
                    level={2}
                    icon={this.props.icon}
                    buttons={this.props.titleActions}
                />
                {this.props.children}
            </div>
        );
    }
}

export default LayoutSidebarPrimary;
